export const random = new Random(Random.engines.mt19937().autoSeed());